import React, {useState} from "react";
import S from './Program.module.scss';
import arrowDown from '../../shared/assets/images/arrow-down-svgrepo-com.svg';
import arrowUp from '../../shared/assets/images/arrow-up-svgrepo-com.svg';

interface ProgramProps {
    event?: any;
}

export const ProgramPanelTwo = ({event}: ProgramProps) => {
    const [isOnePanelOpen, setIsOnePanelOpen] = useState(false);
    const [isSecondPanelOpen, setIsSecondPanelOpen] = useState(false);
    const [isThreePanelOpen, setIsThreePanelOpen] = useState(false);
    const [isFourPanelOpen, setIsFourPanelOpen] = useState(false);

    return (
        <>
            {event === 1 ? (
                <div className={S.panelStyle}>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraph}/>
                        <div className={S.hallPanel}>ЗАЛ ДЕМИДОВ</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanel}><span>ОТКРЫТИЕ ФОРУМА.</span></div>
                            <div className={S.titlePanel}><span>ПЛЕНАРНАЯ ДИСКУССИЯ:</span>«ПРОМЫШЛЕННЫЙ ИИ-СУВЕРЕНИТЕТ: КАК
                                РОССИЙСКИЕ ЛИДЕРЫ СТРОЯТ НЕЗАВИСИМУЮ ЦИФРОВУЮ ЭКОСИСТЕМУ 2030»
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraph}/>
                        <div className={S.hallPanel}>ЗАЛ ДЕМИДОВ</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanel}><span>СЕССИЯ.</span> УПРАВЛЕНИЕ ПРОИЗВОДСТВОМ И ПЕРЕДЕЛАМИ.</div>
                            <div className={`${S.paragraphDivWrapper} ${isOnePanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>MES И ОПТИМИЗАЦИЯ ПЕРЕДЕЛОВ: ЭФФЕКТ 1,8 МЛРД ₽/ГОД НА СТАНЕ
                                        2000
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ОПЕРАТИВНОЕ ПЛАНИРОВАНИЕ ПРОИЗВОДСТВА (APS): ЗАКАЗЫ, СТАНЫ
                                        И ЭНЕРГЕТИКА В ОДНОЙ МОДЕЛИ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ПЛАНИРОВАНИЕ МЕЛКОСЕРИЙНОГО И МНОГОНОМЕНКЛАТУРНОГО
                                        ПРОИЗВОДСТВА: КЕЙС НА 14 000 SKU
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЦИФРОВЫЕ ДВОЙНИКИ ПРОИЗВОДСТВА: ОТ МОДЕЛЕЙ К РЕШЕНИЯМ В
                                        РЕАЛЬНОМ ВРЕМЕНИ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЦИФРОВОЙ ЗАВОД 2.0: EDGE-ВЫЧИСЛЕНИЯ И MES СОБСТВЕННОЙ
                                        РАЗРАБОТКИ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>УПРАВЛЕНИЕ ДОМЕННОЙ ПЕЧЬЮ: ДВА ГОДА В ПРОДУКТИВЕ И ДОРОЖНАЯ
                                        КАРТА СЛЕДУЮЩИХ ПЕРЕДЕЛОВ
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsOnePanelOpen(!isOnePanelOpen)}
                                className={S.button}
                            >
                                {isOnePanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isOnePanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraph}/>
                        <div className={S.hallPanel}>ЗАЛ ДЕМИДОВ</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanel}><span>СЕССИЯ.</span> ОБОРУДОВАНИЕ, ОБСЛУЖИВАНИЕ И ЭНЕРГЕТИКА.</div>
                            <div className={`${S.paragraphDivWrapper} ${isSecondPanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ПРЕДИКТИВНАЯ ДИАГНОСТИКА ОБОРУДОВАНИЯ: 87% ТОЧНОСТИ
                                        ПРОГНОЗА ОТКАЗОВ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>EAM И ТОиР: ОТ БУМАЖНЫХ РЕМОНТОВ К ЦИФРОВОМУ УПРАВЛЕНИЮ
                                        АКТИВАМИ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ПРЕДИКТИВНОЕ ОБСЛУЖИВАНИЕ ПОДВИЖНОГО СОСТАВА: 4,2 МЛРД ₽
                                        ЭКОНОМИИ В ГОД
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЭНЕРГОУЧЁТ И БАЛАНСЫ: АИИС КУЭ КАК БАЗИС
                                        ЭНЕРГОЭФФЕКТИВНОСТИ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЭНЕРГОЭФФЕКТИВНОСТЬ И ДЕКАРБОНИЗАЦИЯ: УЧЁТ РЕСУРСОВ И
                                        ОТЧЁТНОСТЬ SCOPE 1–3
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsSecondPanelOpen(!isSecondPanelOpen)}
                                className={S.button}
                            >
                                {isSecondPanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isSecondPanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraph}/>
                        <div className={S.hallPanel}>ЗАЛ НОБЕЛЬ</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanel}><span>СЕССИЯ.</span> АРХИТЕКТУРА И ИТ-ИНФРАСТРУКТУРА.</div>
                            <div className={`${S.paragraphDivWrapper} ${isThreePanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЦИФРОВОЙ СУВЕРЕНИТЕТ ПРОМЫШЛЕННОСТИ: НЕЗАВИСИМАЯ ЦИФРОВАЯ
                                        ЭКОСИСТЕМА ПРЕДПРИЯТИЯ 2030
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>МИГРАЦИЯ С ЗАРУБЕЖНЫХ IIOT-ПЛАТФОРМ И MES: ПЕРЕНОС ИСТОРИИ
                                        ДАННЫХ БЕЗ ПОТЕРЬ (ZIIOT ВМЕСТО OSISOFT PI, GE PREDIX, SIEMENS MINDSPHERE)
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>РОССИЙСКИЕ СУБД ДЛЯ REAL-TIME ПРОМЫШЛЕННОСТИ: POSTGRES PRO
                                        И TARANTOOL
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЧАСТНЫЕ ОБЛАКА И КОРПОРАТИВНЫЕ КОММУНИКАЦИИ ДЛЯ
                                        ПРОМПЛОЩАДОК
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ИМПОРТОНЕЗАВИСИМАЯ ВИРТУАЛИЗАЦИЯ: ГИПЕРВИЗОРЫ И ОБЛАЧНАЯ
                                        ИНФРАСТРУКТУРА ДЛЯ КИИ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ИМПОРТОНЕЗАВИСИМАЯ ИТ-ЭКСПЛУАТАЦИЯ: SERVICE DESK И
                                        МОНИТОРИНГ ИТ-ЛАНДШАФТА
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>КИБЕРБЕЗОПАСНОСТЬ АСУ ТП И ЗАЩИТА КОНТУРОВ УПРАВЛЕНИЯ
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsThreePanelOpen(!isThreePanelOpen)}
                                className={S.button}
                            >
                                {isThreePanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isThreePanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraph}/>
                        <div className={S.hallPanel}>ЗАЛ НОБЕЛЬ</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanel}><span>СЕССИЯ.</span> ДАННЫЕ ПРОИЗВОДСТВА.</div>
                            <div className={`${S.paragraphDivWrapper} ${isFourPanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>«ЗОЛОТОЙ ИСТОЧНИК» ДАННЫХ: ЕДИНАЯ АРХИТЕКТУРА MES + DATA
                                        LAKE + LIMS
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЕДИНАЯ МОДЕЛЬ ДАННЫХ КАЧЕСТВА: ОТ ЛАБОРАТОРИИ ДО ПРОКАТНОГО
                                        СТАНА
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>DATA LAKE И LAKEHOUSE В САНКЦИОННО-УСТОЙЧИВОМ КОНТУРЕ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ПЛАТФОРМА УПРАВЛЕНИЯ ИНЖЕНЕРНЫМИ ДАННЫМИ «САРУС»: ОПЫТ
                                        ЯДЕРНОЙ И МЕТАЛЛУРГИЧЕСКОЙ ОТРАСЛЕЙ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЕДИНАЯ ШИНА ДАННЫХ И OPC UA: КАК СТАНДАРТИЗОВАТЬ ОБМЕН С
                                        АСУ ТП
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ДОСТОВЕРНОСТЬ ПЕРВИЧНЫХ ДАННЫХ: МЕТРОЛОГИЯ, КИП И КАЧЕСТВО
                                        ИЗМЕРЕНИЙ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>BI И ВИТРИНЫ ДАННЫХ: ОТ КОРПОРАТИВНОЙ ОТЧЁТНОСТИ К
                                        ДАШБОРДАМ ЦЕХА
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ПРОМЫШЛЕННЫЙ MLOPS: ПЕРЕВОД 100+ МОДЕЛЕЙ В ПРОДУКТИВ И ИХ ЭКСПЛУАТАЦИЯ
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsFourPanelOpen(!isFourPanelOpen)}
                                className={S.button}
                            >
                                {isFourPanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isFourPanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={S.panelStyle}>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraphLogistics}/>
                        <div className={S.hallPanel}>ЗАЛ 1</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanelLogistics}><span>СТРАТЕГИЧЕСКАЯ СЕССИЯ.</span></div>
                            <div className={`${S.paragraphDivWrapper} ${S.open}`}>
                                <div className={S.paragraphTextTitle}>АКТУАЛЬНЫЕ ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>СНИЖЕНИЕ ЗАТРАТ, ПОВЫШЕНИЕ ЭФФЕКТИВНОСТИ ВНЕШНИХ И ВНУТРЕННИХ АВТОПОТОКОВ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>Ж/Д ТРАНСПОРТ: СКВОЗНОЕ ПЛАНИРОВАНИЕ ПЕРЕВОЗОК И УПРАВЛЕНИЕ ИНФРАСТРУКТУРОЙ БЕЗ ПРОСТОЕВ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>НАДЁЖНОСТЬ И ТОИР: КТГ И СНИЖЕНИЕ СТОИМОСТИ ВЛАДЕНИЯ ТЕХНИКОЙ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЭКОНОМИКА ЭКСПЛУАТАЦИИ: ЗАПЧАСТИ, ШИНЫ, ТОПЛИВО, ТМЦ — СОКРАЩЕНИЕ УДЕЛЬНОГО РАСХОДА РЕСУРСОВ БЕЗ ПОТЕРИ НАДЁЖНОСТИ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЦИФРОВИЗАЦИЯ, ИИ, БЕСПИЛОТНИКИ И КАДРЫ
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraphLogistics}/>
                        <div className={S.hallPanel}>ЗАЛ 1</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanelLogistics}><span>СЕССИЯ.</span> АВТОМОБИЛЬНЫЙ ТРАНСПОРТ: ВНЕШНЯЯ И ВНУТРЕННЯЯ ЛОГИСТИКА.
                            </div>
                            <div className={`${S.paragraphDivWrapper} ${isOnePanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ВНЕШНЯЯ АВТОЛОГИСТИКА: ОТ СЫРЬЯ ДО КЛИЕНТА — КАК
                                        СНИЗИТЬ ЗАТРАТЫ И ПОВЫСИТЬ ОПЕРАЦИОННУЮ ЭФФЕКТИВНОСТЬ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ВНУТРЕННИЙ ТРАНСПОРТ И СПЕЦТЕХНИКА: САМОСВАЛЫ
                                        (ДОРОЖНЫЕ И КАРЬЕРНЫЕ), БЕЛАЗЫ — ЭКСПЛУАТАЦИЯ, КТГ, НАРАБОТКИ КОЛЛЕГ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>СТРУКТУРА И УПРАВЛЕНИЕ АВТОПАРКОМ: ЛЕГКОВЫЕ,
                                        ГРУЗОВЫЕ, ГАЗЕЛИ — СВОЙ ПАРК VS АУТСОРСИНГ, ЗАКАЗ И ОПЛАТА ПОДРЯДЧИКОВ, ХРАНЕНИЕ
                                        И ТОПЛИВО
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>УПРАВЛЕНИЕ ДВОРОМ АВТОПАРКА (YARD MANAGEMENT): ВНУТРЕННИЕ И ВНЕШНИЕ ПОТОКИ, ПРОМЫШЛЕННОЕ ТАКСИ, ПРИОРИТИЗАЦИЯ МАШИН ПРИ ПЛАНИРОВАНИИ
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsOnePanelOpen(!isOnePanelOpen)}
                                className={S.buttonLogistics}
                            >
                                {isOnePanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isOnePanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraphLogistics}/>
                        <div className={S.hallPanel}>ЗАЛ 1</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanelLogistics}><span>СЕССИЯ.</span> ЖЕЛЕЗНОДОРОЖНЫЙ ТРАНСПОРТ: ИНФРАСТРУКТУРА, ПЕРЕВОЗКИ, СКВОЗНОЕ ПЛАНИРОВАНИЕ.
                            </div>
                            <div className={`${S.paragraphDivWrapper} ${isSecondPanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>Ж/Д ВНЕШНЯЯ И ВНУТРЕННЯЯ ЛОГИСТИКА: СОХРАННОСТЬ В
                                        ПУТИ, ОБЕСПЕЧЕНИЕ ЛТ, ИНСТРУМЕНТЫ КОНТРОЛЯ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ПОДДЕРЖАНИЕ Ж/Д ИНФРАСТРУКТУРЫ: ТЯЖЁЛЫЕ ЛОКОМОТИВЫ,
                                        СЦБ, ЭНЕРГЕТИКА, ПУТИ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>СИСТЕМЫ ПЛАНИРОВАНИЯ Ж/Д ПЕРЕВОЗОК: ПЛАН-НАРЯД,
                                        СКВОЗНОЕ ПЛАНИРОВАНИЕ, ЦИФРОВЫЕ ИНСТРУМЕНТЫ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ВЫВОЗНЫЕ ТЕПЛОВОЗЫ И УПРАВЛЕНИЕ РАМАМИ: УЧЁТ, ВОЗВРАТ ОТ КЛИЕНТА, ЦЕНТРАЛИЗОВАННАЯ VS ДЕЦЕНТРАЛИЗОВАННАЯ СТРУКТУРА
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsSecondPanelOpen(!isSecondPanelOpen)}
                                className={S.buttonLogistics}
                            >
                                {isSecondPanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                {isSecondPanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraphLogistics}/>
                        <div className={S.hallPanel}>ЗАЛ 2</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanelLogistics}><span>СЕССИЯ.</span> РЕМОНТЫ, ТОИР И НАДЁЖНОСТЬ: АВТО, Ж/Д И КАРЬЕРНЫЙ ТРАНСПОРТ.</div>
                            <div className={`${S.paragraphDivWrapper} ${isThreePanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>НАДЁЖНО ОРИЕНТИРОВАННЫЙ ПОДХОД К РЕМОНТАМ
                                        АВТОТРАНСПОРТА: ПРОБЛЕМЫ, ВНЕДРЕНИЕ ИНСТРУМЕНТОВ, АГРЕГАЦИЯ ДАННЫХ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>РЕМОНТ И ОПЕРАЦИОННАЯ ЭФФЕКТИВНОСТЬ Ж/Д ТРАНСПОРТА:
                                        ОПЫТ ПРИМЕНЕНИЯ ПОЛИМЕРНЫХ МАТЕРИАЛОВ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ТОИР КАРЬЕРНОЙ ТЕХНИКИ: КТГ БЕЛАЗОВ И ЭКСКАВАТОРОВ,
                                        НАРАБОТКИ КОЛЛЕГ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ИНСТРУМЕНТЫ АНАЛИЗА НАДЁЖНОСТИ (РСМ): ЭФФЕКТЫ, НАГРУЗКА НА СОТРУДНИКОВ, УПРАВЛЕНИЕ ДАННЫМИ
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsThreePanelOpen(!isThreePanelOpen)}
                                className={S.buttonLogistics}
                            >
                                {isThreePanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                {isThreePanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraphLogistics}/>
                        <div className={S.hallPanel}>ЗАЛ 2</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanelLogistics}><span>СЕССИЯ.</span> ЗАПЧАСТИ, ШИНЫ, ТОПЛИВО И ТМЦ: ЗАКУПКА, УЧЁТ, ЭКОНОМИЯ.</div>
                            <div className={`${S.paragraphDivWrapper} ${isFourPanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>УПРАВЛЕНИЕ ЗАПАСАМИ ТМЦ И НОМЕНКЛАТУРОЙ: УДЕЛЬНЫЙ РАСХОД, ХРАНЕНИЕ, НОРМИРОВАНИЕ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЗАКУПКА ЗАПЧАСТЕЙ: ТОРГИ VS ПРЯМЫЕ КОНТРАКТЫ, ЦЕНООБРАЗОВАНИЕ, СПИСАНИЕ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ШИНЫ И АККУМУЛЯТОРЫ: ОПЫТ И ЛУЧШИЕ ПРАКТИКИ — КАКИЕ ШИНЫ ДАЮТ МАКСИМАЛЬНЫЙ ПРОБЕГ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЭКОНОМИЯ ТОПЛИВА: ВОДОРОДНАЯ ОЧИСТКА, ПРИСАДКИ, КОНТРОЛЬ СМЕШИВАНИЯ, ИЗМЕРЯЕМЫЙ ЭФФЕКТ
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsFourPanelOpen(!isFourPanelOpen)}
                                className={S.buttonLogistics}
                            >
                                {isFourPanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isFourPanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};